import { render, staticRenderFns } from "./Teken.vue?vue&type=template&id=9f98e644&scoped=true"
import script from "./Teken.vue?vue&type=script&lang=js"
export * from "./Teken.vue?vue&type=script&lang=js"
import style0 from "./Teken.vue?vue&type=style&index=0&id=9f98e644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f98e644",
  null
  
)

export default component.exports